import markdownGuide from '../../../../../data/markdown/markdown_guide_lists.json';
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography';
import ReactMarkdown from 'react-markdown';

const MarkdownGuideLists = ({ isMobile }) => {
    return (
        <div className="markdown-guide-lists markdown-guide">
            <Typography variant="h4">{markdownGuide.title}</Typography>
            <ReactMarkdown>
                {markdownGuide.description}
            </ReactMarkdown>
            <table className="markdown-guide-table">
                <tr>
                    <th>Style</th>
                    <th>Syntax</th>
                    <th>Example</th>
                    {!isMobile && <th>Output</th>}
                </tr>
                {markdownGuide.guides.map((guide, index) => {
                    return (
                        <tr key={index}>
                            <td>{guide.style}</td>
                            <td>{guide.syntax}</td>
                            <td style={{ whiteSpace: 'pre-wrap' }}>{guide.example}</td>
                            {!isMobile && <td><ReactMarkdown>{guide.example}</ReactMarkdown></td>}
                        </tr>
                    )
                })}
            </table>
            <Divider />
        </div>
    )
}

export default MarkdownGuideLists;

